import { GlobalActions, InitializeShopPayload } from '@ps20-frontend/shop-integration-redux';
import { AnyAction } from 'redux';

export function azamVorgangsIdReducer(sectionState: string = '', action: AnyAction): string {
  if (action.type === GlobalActions.SHOP_INIT) {
    const actionPayload: InitializeShopPayload = action.payload;
    return actionPayload.azamVorgangsId;
  }
  return sectionState;
}
